import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchCreditTransactionsApi } from 'api/patients-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  data: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchPatientReferralsListing = createAsyncThunk(
  'patient-referrals/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
    try {
      const paramsObj = {
        ...updatedParamsObject,
      };
      const res = await fetchCreditTransactionsApi(paramsObj, '');
      if (res?.status) {
        dispatch(setQuickLinks(res?.user_filters));
      }
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

const PatientReferralsSlice = createSlice({
  name: 'patient-referrals',
  initialState,
  reducers: {
    setPatientReferralsLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setPatientReferralsActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchPatientReferralsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchPatientReferralsListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.data = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchPatientReferralsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setPatientReferralsActiveColumn, setPatientReferralsLoading } = PatientReferralsSlice.actions;
export default PatientReferralsSlice.reducer;
